'use client'

import { RadioSingleSelect } from '@components/primitives/HtmlForm/RadioSingleSelect.client'
import { Text } from '@components/primitives/Text'
import { milesToKilometers } from '@lib/utilities/distance/milesToMeters'
import { useRef, useState } from 'react'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { DemographicsCollectElementProps } from './types'

const fiftyMilesInKm = milesToKilometers(50)
const oneHundredMilesInKm = milesToKilometers(100)
const twoHundredMilesInKm = milesToKilometers(200)
const debouncedEventTracking = debounceTrackQuestionModified(
  'distanceWillingToTravelInKm',
)

export default function CollectDistanceWillingToTravel({
  formRef,
  patientProfileData: { distanceWillingToTravelInKm },
  questionConfig,
}: DemographicsCollectElementProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const [currentValue, setCurrentValue] = useState(
    distanceWillingToTravelInKm[0],
  )

  const handleInputChange = (newInputValue: string | string[]) => {
    debouncedEventTracking(newInputValue)
    setCurrentValue([newInputValue].flat()[0])
    const selectedValue = [newInputValue].flat()[0]

    if (inputRef.current && selectedValue) {
      // Needed to have the input value updated before submitting the form below
      inputRef.current.value = selectedValue
    }

    if (formRef && formRef.current) {
      formRef.current.requestSubmit()
    }
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='How far are you willing to travel?'
      />
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='p-small'
        value='Why we ask: to recommend you trials within your preferred travel distance.'
      />
      <div className='grid grid-cols-1 gap-2'>
        <RadioSingleSelect
          defaultValue={currentValue}
          name={questionConfig.id}
          onChange={handleInputChange}
          options={[
            { label: '50 Miles', value: fiftyMilesInKm.toString() },
            { label: '100 Miles', value: oneHundredMilesInKm.toString() },
            { label: '200 Miles', value: twoHundredMilesInKm.toString() },
            { label: 'Any Distance', value: 'any' },
          ]}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}
